import styled from "styled-components";

const VideoPlayerContainer = styled.div`
  position: ${(props) => (!props.id ? "fixed" : "relative")};
  width: ${(props) => (!props.id ? "420px" : "100%")};
  height: fit-content;
  z-index: ${(props) => (!props.id ? 99 : 10)};
  bottom: 0;
  right: ${(props) => (!props.id ? "20px" : "0px")};
  cursor: ${(props) => (!props.id ? "grab" : "")};
  transform: ${(props) => (!props.id ? "" : "none !important")};
  display: ${(props) => (!props.id ? "flex" : "")};
  flex-direction: column;
  gap: 16px;
  margin: ${(props) => (!props.id ? "0px 20px" : "0px")};
  padding: ${(props) => (!props.id ? "20px" : "0px")};
  background-color: ${(props) => (!props.id ? "white" : "")};
  border-radius: 8px;
  animation: ${(props) => (!props.id ? "showing 2s" : "")};
  overflow: hidden;
  @keyframes showing {
    0% {
      opacity: 0;
      transform: translateY(200px);
      animation-timing-function: ease-in-out;
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
      animation-timing-function: ease-in-out;
    }
  }
`;

export default VideoPlayerContainer;
